<template>
  <a class="skip-nav" href="#" @click.prevent="skipTo">{{ text }}</a>
</template>

<script>
export default {
  name: "lms-skip-nav",
  props: {
    text: {
      type: String,
      default: "Skip to main content",
    },
  },
  methods: {
    skipTo() {
      // identify the main landmark
      const target = document.querySelectorAll("main")[0];

      // Set the target div's tabindex and focus on it
      target.tabIndex = -1;
      target.focus();

      // when the target is blurred, remove that tabindex setting
      target.addEventListener("blur", () => {
        target.removeAttribute("tabIndex");
      });
    },
  },
};
</script>
